import { http } from '../client';
import type { CallOptions, WriteOptions } from '../types';
import type { ZnsApi } from './zns';

// Paths mirror subsystems/communications/facade/adapters/admin-api/src/admin/zns.rs.
const seg = encodeURIComponent;
const rd = (o?: CallOptions) => ({ signal: o?.signal });
const wr = (o?: WriteOptions) => ({ signal: o?.signal, idempotencyKey: o?.idempotencyKey, notifyCustomer: o?.notifyCustomer });

export const znsHttp: ZnsApi = {
  getZnsOverview: (opts) => http.get('api', '/notify/zns', rd(opts)),
  listZnsTemplates: (opts) => http.get('api', '/notify/zns/templates', rd(opts)),
  saveZnsTemplate: (key, body, opts) => http.put('api', `/notify/zns/templates/${seg(key)}`, body, wr(opts)),
  deleteZnsTemplate: (key, opts) => http.delete('api', `/notify/zns/templates/${seg(key)}`, wr(opts)),
  describeZnsTemplate: (key, body, opts) => http.post('api', `/notify/zns/templates/${seg(key)}/describe`, body, wr(opts)),
  testZnsTemplate: (key, body, opts) => http.post('api', `/notify/zns/templates/${seg(key)}/test`, body, wr(opts)),
  listZnsMessages: (query, opts) => http.get('api', '/notify/zns/messages', { query: { ...query }, ...rd(opts) }),
  getZnsMessage: (id, opts) => http.get('api', `/notify/zns/messages/${seg(id)}`, rd(opts)),
  resendZnsMessage: (id, opts) => http.post('api', `/notify/zns/messages/${seg(id)}/resend`, {}, wr(opts)),
  listZnsOptOuts: (query, opts) => http.get('api', '/notify/zns/opt-outs', { query: { ...query }, ...rd(opts) }),
  addZnsOptOut: (body, opts) => http.post('api', '/notify/zns/opt-outs', body, wr(opts)),
  withdrawZnsOptOut: (id, opts) => http.post('api', `/notify/zns/opt-outs/${seg(id)}/withdraw`, {}, wr(opts)),
};
